export const LISTING_TYPES = { SALE: "Satılık", RENT: "Kiralık" };
export const PROPERTY_TYPES = ["1+0", "1+1", "2+1", "3+1", "4+1", "5+1", "VILLA", "ARSA", "ISYERI"];
export const STATUS_LABEL = { ACTIVE: "Yayında", SOLD: "Satıldı", RENTED: "Kiralandı" };
export const FACADES = { NORTH: "Kuzey", SOUTH: "Güney", EAST: "Doğu", WEST: "Batı" };
export const VIEWS = { SEA: "Deniz", BOSPHORUS: "Boğaz", CITY: "Şehir", NATURE: "Doğa", LAKE: "Göl", FOREST: "Orman", MOUNTAIN: "Dağ", POOL: "Havuz" };
export const FLOORS = [
  "Kot 2", "Kot 1", "Bodrum Kat", "Zemin Kat", "Bahçe Katı", "Yüksek Giriş",
  ...Array.from({ length: 40 }, (_, i) => `${i + 1}. Kat`),
  "Çatı Katı", "Villa Tipi",
];

export const labelList = (keys, map) => (keys || []).map((k) => map[k] || k).join(", ");
